var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "230px",
    height: "230px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "  .st0{fill:#43DC94;}  "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512,220.891h-20.453c-5.531-16.641-14.797-31.594-26.891-43.656c-20.094-20.125-48.063-32.625-78.75-32.625 c-49.438,0.016-91.266,32.219-105.828,76.766c-7.641-2.25-15.703-3.5-24.078-3.5c-8.359,0-16.438,1.25-24.078,3.5 c-14.563-44.547-56.391-76.75-105.828-76.766c-30.688,0-58.656,12.5-78.75,32.625c-12.094,12.063-21.359,27.016-26.891,43.656H0 v32.172h14.859c-0.031,0.984-0.141,1.953-0.141,2.938c0,61.516,49.859,111.375,111.375,111.391 c61.531-0.016,111.375-49.875,111.391-111.391c0-0.828-0.109-1.625-0.109-2.438c5.75-2.203,11.984-3.516,18.625-3.516 s12.875,1.313,18.625,3.516c0,0.813-0.109,1.609-0.109,2.438c0.016,61.516,49.859,111.375,111.391,111.391 c30.688,0,58.656-12.516,78.75-32.625c20.141-20.094,32.641-48.078,32.625-78.766c0-0.984-0.109-1.953-0.141-2.938H512V220.891z M176.438,306.328c-12.953,12.906-30.625,20.844-50.344,20.844s-37.375-7.938-50.328-20.844 C62.859,293.375,54.938,275.719,54.922,256c0.016-19.719,7.938-37.391,20.844-50.328c12.953-12.922,30.609-20.844,50.328-20.844 s37.391,7.922,50.344,20.844c12.906,12.938,20.828,30.594,20.844,50.328C197.266,275.719,189.344,293.375,176.438,306.328z M436.234,306.328c-12.953,12.906-30.609,20.844-50.328,20.844s-37.391-7.938-50.344-20.844 c-12.906-12.953-20.828-30.609-20.844-50.328c0.016-19.719,7.938-37.391,20.844-50.328c12.953-12.922,30.625-20.844,50.344-20.844 s37.375,7.922,50.328,20.844c12.906,12.938,20.828,30.609,20.844,50.328C457.063,275.719,449.141,293.375,436.234,306.328z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlasses);
export default __webpack_public_path__ + "static/media/glasses.fe09380236278030ad419dbb904c6976.svg";
export { ForwardRef as ReactComponent };